/* eslint-disable array-bracket-newline */

export const COURSE_FIELD_OPTIONS = [
  // general info
  { label: 'Subject Code', path: [ 'subjectCode' ] },
  { label: 'Course Number', path: [ 'courseNumber' ] },
  { label: 'Name', path: [ 'name' ] },
  { label: 'Long Name', path: [ 'longName' ] },
  { label: 'Code', path: [ 'code' ] },
  { label: 'Status', path: [ 'status' ] },
  { label: 'Description', path: [ 'description' ] },
  { label: 'Career', path: [ 'career' ] },
  { label: 'Designation', path: [ 'designation' ] },
  { label: 'Type', path: [ 'type' ] },
  { label: 'Instruction Mode', path: [ 'instructionMode' ] },
  { label: 'Registration Mode', path: [ 'registrationMode' ] },
  { label: 'Grade Mode', path: [ 'gradeMode' ] },
  { label: 'Attributes', path: [ 'attributes' ] },
  { label: 'Categories', path: [ 'categories' ] },
  { label: 'Files', path: [ 'files' ] },
  { label: 'Consent', path: [ 'consent' ] },
  { label: 'Drop Consent', path: [ 'dropConsent' ] },
  { label: 'Notes', path: [ 'notes' ] },
  { label: 'Crosslisted Courses', path: [ 'crossListedCourses' ] },

  // Powercampus  SIS Field
  { label: 'Career Code', path: [ 'careerCode' ] },

  // Peoplesoft SIS fields
  { label: 'Course Typically Offered', path: [ 'courseTypicallyOffered' ] },
  { label: 'Schedule Print', path: [ 'schedulePrint' ] },
  { label: 'Blind Grading', path: [ 'blindGrading' ] },
  { label: 'Grade Roster Print', path: [ 'gradeRosterPrint' ] },
  { label: 'Requirement Designation', path: [ 'requirementDesignation' ] },
  { label: 'Requirement Group', path: [ 'requirementGroup' ] },
  { label: 'Tuition Group', path: [ 'tuitionGroup' ] },
  { label: 'Instructor Edit', path: [ 'instructorEdit' ] },
  { label: 'Dynamic Class Date Rule', path: [ 'dynamicClassDateRule' ] },
  { label: 'CIP Code', path: [ 'cipCode' ] },
  { label: 'Hegis Code', path: [ 'hegisCode' ] },
  { label: 'Equivalent Course Group', path: [ 'equivalentCourseGroup' ] },
  { label: 'Course Approved', path: [ 'courseApproved' ] },
  { label: 'Dynamic CLass Date Rule', path: [ 'dynamicClassDateRule' ] },
  { label: 'Print Instructor In Schedule', path: [ 'printInstructorInSchedule' ] },

  // Peoplesoft Component Fields
  { label: 'Component Code', path: [ 'components', '$', 'code' ] },
  { label: 'Component Name', path: [ 'components', '$', 'name' ] },
  { label: 'LMS File Type', path: [ 'components', '$', 'lmsFileType' ] },
  { label: 'Attendance Type', path: [ 'components', '$', 'attendanceType' ] },
  { label: 'Final Exam Type', path: [ 'components', '$', 'finalExamType' ] },
  { label: 'Provider For Authentication', path: [ 'components', '$', 'providerForAuthentication' ] },
  { label: 'Exam Seat Spacing', path: [ 'components', '$', 'examSeatSpacing' ] },
  { label: 'Preferred Room Features', path: [ 'components', '$', 'preferredRoomFeatures' ] },
  { label: 'Instruction Mode', path: [ 'components', '$', 'instructionMode' ] },
  { label: 'Component Credit Hours', path: [ 'components', '$', 'creditHours' ] },
  { label: 'Component Contact Hours', path: [ 'components', '$', 'contactHours' ] },
  { label: 'Component Workload Hours', path: [ 'components', '$', 'workloadHours' ] },
  { label: 'Component OEE Workload Hours', path: [ 'components', '$', 'oeeWorkloadHours' ] },
  { label: 'Component Default Section Size', path: [ 'components', '$', 'defaultSectionSize' ] },

  // Workday Component Fields
  { label: 'Delivery Mode', path: [ 'components', '$', 'deliveryMode' ] },

  // ownership
  { label: 'Campus', path: [ 'campus' ] },
  { label: 'Campuses', path: [ 'campuses' ] },
  { label: 'Departments', path: [ 'departments' ] },
  { label: 'Owners', path: [ 'owners' ] },
  { label: 'Division', path: [ 'division' ] },
  { label: 'College', path: [ 'college' ] },

  // nested fields
  { label: 'Credits', path: [ 'credits' ] },
  { label: 'Topics', path: [ 'topics' ] },
  { label: 'Learnng Outcomes', path: [ 'learningOutcomes' ] },
  { label: 'Instructional Methods', path: [ 'instructionalMethods' ] },
  { label: 'Requirements', path: [ 'requisites' ] },
  { label: 'Components', path: [ 'components' ] },

  // sis info
  { label: 'Primary Component', path: [ 'primaryComponent' ] },
  { label: 'Graded Component', path: [ 'gradedComponent' ] },

  // meta info
  { label: 'Created At', path: [ 'createdAt' ] },
  { label: 'Created By', path: [ 'createdBy' ] },
  { label: 'Last Edited At', path: [ 'lastEdited' ] },
  { label: 'Last Edited By', path: [ 'lastEditedBy' ] },
  { label: 'Version', path: [ 'version' ] },
  { label: 'Deprecated Coursedog Id', path: [ 'deprecatedId' ] },
  { label: 'Deprecated Coursedog Group Id', path: [ 'deprecatedCourseGroupId' ] },
  { label: 'Schedule Display Name', path: [ 'scheduleDisplayName' ] },
  { label: 'Allow Integration', path: [ 'allowIntegration' ] },
  { label: 'Object Merge Settings', path: [ 'objectMergeSettings' ] },
  { label: 'Course Group Id', path: [ 'courseGroupId' ] },
  { label: 'Raw SIS ID', path: [ 'customFields.rawCourseId' ] },

  // custom fields
  { label: 'Custom Fields', path: [ 'customFields' ] },

]

export const COURSE_CM_FIELD_OPTIONS = [

  // general info
  { label: 'Subject Code', path: [ 'subjectCode' ] },
  { label: 'Course Number', path: [ 'courseNumber' ] },
  { label: 'Name', path: [ 'name' ] },
  { label: 'Long Name', path: [ 'longName' ] },
  { label: 'Code', path: [ 'code' ] },
  { label: 'Status', path: [ 'status' ] },
  { label: 'Description', path: [ 'description' ] },
  { label: 'Career', path: [ 'career' ] },
  { label: 'designation', path: [ 'designation' ] },
  { label: 'type', path: [ 'type' ] },
  { label: 'Instruction Mode', path: [ 'instructionMode' ] },
  { label: 'Registration Mode', path: [ 'registrationMode' ] },
  { label: 'Grade Mode', path: [ 'gradeMode' ] },
  { label: 'Attributes', path: [ 'attributes' ] },
  { label: 'Categories', path: [ 'categories' ] },
  { label: 'Files', path: [ 'files' ] },
  { label: 'Consent', path: [ 'consent' ] },
  { label: 'Drop Consent', path: [ 'dropConsent' ] },
  { label: 'Notes', path: [ 'courseNotes' ] },
  { label: 'Crosslisted Courses', path: [ 'crossListedCourses' ] },

  // Powercampus  SIS Field
  { label: 'Career Code', path: [ 'careerCode' ] },

  // Peoplesoft SIS fields
  { label: 'Course Typically Offered', path: [ 'courseTypicallyOffered' ] },
  { label: 'Schedule Print', path: [ 'schedulePrint' ] },
  { label: 'Blind Grading', path: [ 'blindGrading' ] },
  { label: 'Grade Roster Print', path: [ 'gradeRosterPrint' ] },
  { label: 'Requirement Designation', path: [ 'requirementDesignation' ] },
  { label: 'Requirement Group', path: [ 'requirementGroup' ] },
  { label: 'Tuition Group', path: [ 'tuitionGroup' ] },
  { label: 'Instructor Edit', path: [ 'instructorEdit' ] },
  { label: 'Dynamic Class Date Rule', path: [ 'dynamicClassDateRule' ] },
  { label: 'CIP Code', path: [ 'cipCode' ] },
  { label: 'Hegis Code', path: [ 'hegisCode' ] },
  { label: 'Equivalent Course Group', path: [ 'equivalentCourseGroup' ] },
  { label: 'Course Approved', path: [ 'courseApproved' ] },
  { label: 'Dynamic CLass Date Rule', path: [ 'dynamicClassDateRule' ] },
  { label: 'Print Instructor In Schedule', path: [ 'printInstructorInSchedule' ] },

  // Peoplesoft Component Fields
  { label: 'Component Code', path: [ 'components', '$', 'code' ] },
  { label: 'Component Name', path: [ 'components', '$', 'name' ] },
  { label: 'LMS File Type', path: [ 'components', '$', 'lmsFileType' ] },
  { label: 'Attendance Type', path: [ 'components', '$', 'attendanceType' ] },
  { label: 'Final Exam Type', path: [ 'components', '$', 'finalExamType' ] },
  { label: 'Provider For Authentication', path: [ 'components', '$', 'providerForAuthentication' ] },
  { label: 'Exam Seat Spacing', path: [ 'components', '$', 'examSeatSpacing' ] },
  { label: 'Preferred Room Features', path: [ 'components', '$', 'preferredRoomFeatures' ] },
  { label: 'Instruction Mode', path: [ 'components', '$', 'instructionMode' ] },
  { label: 'Component Credit Hours', path: [ 'components', '$', 'creditHours' ] },
  { label: 'Component Contact Hours', path: [ 'components', '$', 'contactHours' ] },
  { label: 'Component Workload Hours', path: [ 'components', '$', 'workloadHours' ] },
  { label: 'Component OEE Workload Hours', path: [ 'components', '$', 'oeeWorkloadHours' ] },
  { label: 'Component Default Section Size', path: [ 'components', '$', 'defaultSectionSize' ] },

  // Workday Component Fields
  { label: 'Delivery Mode', path: [ 'components', '$', 'deliveryMode' ] },

  // ownership
  { label: 'Campus', path: [ 'campus' ] },
  { label: 'Departments', path: [ 'departments' ] },
  { label: 'Owners', path: [ 'owners' ] },
  { label: 'Division', path: [ 'division' ] },
  { label: 'College', path: [ 'college' ] },

  // nested fields
  { label: 'Credits', path: [ 'credits' ] },
  { label: 'Topics', path: [ 'topics' ] },
  { label: 'Learnng Outcomes', path: [ 'learningOutcomes' ] },
  { label: 'Instructional Methods', path: [ 'instructionalMethods' ] },
  { label: 'Requirements', path: [ 'requisites' ] },
  { label: 'Components', path: [ 'components' ] },

  // sis info
  { label: 'Primary Component', path: [ 'primaryComponent' ] },
  { label: 'Graded Component', path: [ 'gradedComponent' ] },

  // meta info
  { label: 'Created At', path: [ 'createdAt' ] },
  { label: 'Created By', path: [ 'createdBy' ] },
  { label: 'Last Edited At', path: [ 'lastEdited' ] },
  { label: 'Last Edited By', path: [ 'lastEditedBy' ] },
  { label: 'Version', path: [ 'version' ] },
  { label: 'Deprecated Coursedog Id', path: [ 'deprecatedId' ] },
  { label: 'Deprecated Coursedog Group Id', path: [ 'deprecatedCourseGroupId' ] },
  { label: 'Schedule Display Name', path: [ 'scheduleDisplayName' ] },
  { label: 'Allow Integration', path: [ 'allowIntegration' ] },
  { label: 'Object Merge Settings', path: [ 'objectMergeSettings' ] },
  { label: 'Course Group Id', path: [ 'courseGroupId' ] },
  { label: 'Raw SIS ID', path: [ 'customFields.rawCourseId' ] },

  // custom fields
  { label: 'Custom Fields', path: [ 'customFields' ] },
]

export const SECTION_FIELD_OPTIONS = [
  // general
  { label: 'Section Number', path: [ 'sectionNumber' ] },
  { label: 'Call Number', path: [ 'callNumber' ] },
  { label: 'Section Name', path: [ 'sectionName' ] },
  { label: 'Section Type', path: [ 'sectionType' ] },
  { label: 'Campus', path: [ 'campus' ] },
  { label: 'Location', path: [ 'location' ] },
  { label: 'Holiday Schedule', path: [ 'holidaySchedule' ] },
  { label: 'Instruction Mode', path: [ 'instructionMode' ] },
  { label: 'Registration Mode', path: [ 'registrationMode' ] },
  { label: 'Grade Mode', path: [ 'gradeMode' ] },
  { label: 'Gradable', path: [ 'gradable' ] },
  { label: 'College', path: [ 'college' ] },
  { label: 'Part of Term', path: [ 'partOfTerm' ] },
  { label: 'Topic', path: [ 'topic' ] },
  { label: 'Notes', path: [ 'sectionNotes' ] },
  { label: 'Notes List', path: [ 'notesList' ] },
  { label: 'Reserve Capacity', path: [ 'reserveCapacity' ] },

  { label: 'Attributes', path: [ 'sectionAttributes' ] },
  { label: 'Start Date', path: [ 'startDate' ] },
  { label: 'End Date', path: [ 'endDate' ] },
  { label: 'Status', path: [ 'status' ] },

  // credits
  { label: 'Credit Hours', path: [ 'creditHours' ] },
  { label: 'Min Credit Hours', path: [ 'minCreditHours' ] },
  { label: 'Max Credit Hours', path: [ 'maxCreditHours' ] },
  { label: 'Billing Hours', path: [ 'billingHours' ] },
  { label: 'Contact Hours', path: [ 'contactHours' ] },
  { label: 'Workload Hours', path: [ 'workloadHours' ] },
  { label: 'Lecture Hours', path: [ 'lectureHours' ] },
  { label: 'Lab Hours', path: [ 'labHours' ] },
  { label: 'Other Hours', path: [ 'otherHours' ] },
  { label: 'Academic Progress Hours', path: [ 'academicProgressHours' ] },
  { label: 'Financial Aid Hours', path: [ 'financialAidHours' ] },

  // profs and students
  { label: 'Professors', path: [ 'professors' ] },
  { label: 'Professors Meta', path: [ 'professorsMeta' ] },
  { label: 'Professor Role', path: [ 'professorsMeta', '$', 'role' ] },
  { label: 'Professor Meeting', path: [ 'professorsMeta', '$', 'timeIndex' ] },
  { label: 'Professor Assign Type', path: [ 'professorsMeta', '$', 'professorAssignType' ] },
  { label: 'Professor Employee Record', path: [ 'professorsMeta', '$', 'professorEmployeeRecord' ] },
  { label: 'Professor Workload', path: [ 'professorsMeta', '$', 'professorWorkload' ] },
  { label: 'Professor Load Factor', path: [ 'professorsMeta', '$', 'professorLoadFactor' ] },
  { label: 'Professor Print', path: [ 'professorsMeta', '$', 'professorPrint' ] },
  { label: 'Professor Access', path: [ 'professorsMeta', '$', 'professorAccess' ] },
  { label: 'Professor Eval Req', path: [ 'professorsMeta', '$', 'professorEvalReq' ] },
  { label: 'Professor Auto Calc', path: [ 'professorsMeta', '$', 'professorAutoCalc' ] },
  { label: 'Professor Ignore Double Bookings', path: [ 'professorsMeta', '$', 'professorIgnoreDoubleBookings' ] },

  { label: 'Students', path: [ 'students' ] },

  // enrollment
  { label: 'Enrollment', path: [ 'enrollment' ] },
  { label: 'Waitlist', path: [ 'waitlist' ] },
  { label: 'Max Enrollment', path: [ 'maxEnrollment' ] },
  { label: 'Min Enrollment', path: [ 'minEnrollment' ] },
  { label: 'Max Waitlist', path: [ 'maxWaitlist' ] },
  { label: 'Prior Enrollment', path: [ 'priorEnrollment' ] },
  { label: 'Combined Max Enrollment', path: [ 'combinedMaxEnrollment' ] },
  { label: 'Projected Enrollment', path: [ 'projectedEnrollment' ] },
  { label: 'Projected Waitlist', path: [ 'projectedWaitlist' ] },

  // times
  { label: 'Times', path: [ 'times' ] },
  { label: 'Time ID', path: [ 'times', '$', 'id' ] },
  { label: 'Time Start Date', path: [ 'times', '$', 'startDate' ] },
  { label: 'Time End Date', path: [ 'times', '$', 'endDate' ] },
  { label: 'Time Room', path: [ 'times', '$', 'classroom' ] },
  { label: 'Time Topic', path: [ 'times', '$', 'topic' ] },
  { label: 'Time Free Format Topic', path: [ 'times', '$', 'freeFormatTopic' ] },
  { label: 'Time Print Topic', path: [ 'times', '$', 'printTopic' ] },
  { label: 'Time Ignore Double Bookings', path: [ 'times', '$', 'ignoreDoubleBookings' ] },
  { label: 'Time Override Indicator', path: [ 'times', '$', 'overrideIndicator' ] },

  // final exam
  { label: 'Final Exam Type', path: [ 'finalExamType' ] },
  { label: 'Exam Meetings', path: [ 'examMeetings' ] },

  // relationships
  { label: 'Relationships', path: [ 'relationships' ] },
  { label: 'Linked Sections', path: [ 'linkedSections' ] },
  { label: 'Cross Enrolled Sections', path: [ 'crossEnrolledSections' ] },

  // textbooks and course materials
  { label: 'Course Materials', path: [ 'courseMaterials' ] },

  // custom fields
  { label: 'Custom Fields', path: [ 'customFields' ] },

  // requests
  { label: 'Rule Exceptions', path: [ 'ruleExceptions' ] },
  { label: 'Requests', path: [ 'requests' ] },

  // Preferences
  { label: 'Preferred Building', path: [ 'preferredBuilding' ] },
  { label: 'Preferred Buildings', path: [ 'preferredBuildings' ] },
  { label: 'Preferred Rooms', path: [ 'preferredRooms' ] },
  { label: 'Preferred Room Type', path: [ 'preferredRoomType' ] },
  { label: 'Preferred Room Capacity', path: [ 'preferredRoomCapacity' ] },
  { label: 'Preferred Room Features', path: [ 'preferredRoomFeatures' ] },

  // peoplesoft Fields
  { label: 'Schedule Print', path: [ 'schedulePrint' ] },
  { label: 'Blind Grading', path: [ 'blindGrading' ] },
  { label: 'Grade Roster Print', path: [ 'gradeRosterPrint' ] },
  { label: 'Requirement Designation', path: [ 'requirementDesignation' ] },
  { label: 'Requirement Group', path: [ 'requirementGroup' ] },
  { label: 'Instructor Edit', path: [ 'instructorEdit' ] },
  { label: 'Course Count', path: [ 'courseCount' ] },
  { label: 'Consent', path: [ 'consent' ] },
  { label: 'Drop Consent', path: [ 'dropConsent' ] },
  { label: 'Section Roll', path: [ 'sectionRoll' ] },

  // meta info
  { label: 'Created At', path: [ 'createdAt' ] },
  { label: 'Created By', path: [ 'createdBy' ] },
  { label: 'Last Edited At', path: [ 'lastEditedAt' ] },
  { label: 'Last Edited By', path: [ 'lastEditedBy' ] },
  { label: 'Created Internally', path: [ 'createdInternally' ] },
  { label: 'Version', path: [ 'version' ] },
  { label: 'Display Code', path: [ 'displayCode' ] },
  { label: 'Deprecated Coursedog Id', path: [ 'deprecatedId' ] },
  { label: 'Allow Integration', path: [ 'allowIntegration' ] },
  { label: 'Object Merge Settings', path: [ 'objectMergeSettings' ] },

  // optimizer info
  { label: 'Do Room Scheduling', path: [ 'doRoomScheduling' ] },
  { label: 'Do Time Scheduling', path: [ 'doTimeScheduling' ] },
  { label: 'Do Exam Scheduling', path: [ 'doExamScheduling' ] },
]

export const PROFESSOR_FIELD_OPTIONS = [
  { label: 'First Name', path: [ 'firstName' ] },
  { label: 'Last Name', path: [ 'lastName' ] },
  { label: 'Bio', path: [ 'bio' ] },
  { label: 'Type', path: [ 'type' ] },
  { label: 'Email', path: [ 'email' ] },
  { label: 'Departments', path: [ 'departments' ] },
  { label: 'Status', path: [ 'status' ] },
  { label: 'Institution ID', path: [ 'institutionId' ] },
  { label: 'Optimizer Priority', path: [ 'optimizerPriority' ] },
  { label: 'Credit Hours', path: [ 'creditHours' ] },
  { label: 'Preferences', path: [ 'preferences' ] },
  { label: 'Approved Courses', path: [ 'approvedCourses' ] },
  { label: 'Teaching Load', path: [ 'teachingLoad' ] },
  { label: 'Catalog Departments', path: [ 'catalogDepartments' ] },
  // custom fields
  { label: 'Custom Fields', path: [ 'customFields' ] },
]

export const ROOM_FIELD_OPTIONS = [
  { label: 'Name', path: [ 'name' ] },
  { label: 'Display Name', path: [ 'displayName' ] },
  { label: 'Number', path: [ 'roomNumber' ] },
  { label: 'Building', path: [ 'buildingId' ] },
  { label: 'Exclude From Optimizer', path: [ 'excludeFromOptimizer' ] },
  { label: 'Type', path: [ 'type' ] },
  { label: 'Campus', path: [ 'campus' ] },
  { label: 'Floor', path: [ 'floor' ] },
  { label: 'Capacity', path: [ 'capacity' ] },
  { label: 'Minimum Capacity', path: [ 'minCapacity' ] },
  { label: 'Minimum Seat Utilization', path: [ 'minimumSeatUtilization' ] },
  { label: 'Departments', path: [ 'departments' ] },
  { label: 'Layouts', path: [ 'layouts' ] },
  { label: 'Attributes', path: [ 'attributes' ] },
  { label: 'Features', path: [ 'features' ] },
  { label: 'Notes', path: [ 'notes' ] },
  { label: 'Status', path: [ 'status' ] },
  { label: 'Online', path: [ 'online' ] },
  { label: 'Image URLs', path: [ 'imageUrls' ] },
  { label: 'Workflow Step', path: [ 'workflowStep' ] },
  { label: 'Owners', path: [ 'owners' ] },
  { label: 'Released', path: [ 'released' ] },
  { label: 'Popularity Index', path: [ 'popularityIndex' ] },
  { label: 'Allowed Sections', path: [ 'allowedSections' ] },
  { label: 'Available Times', path: [ 'availableTimes' ] },
  { label: 'Academic Block Out Times', path: [ 'blockedOutTimes' ] },
  { label: 'Event Blackout Dates', path: [ 'blackoutDates' ] },
  { label: 'Effective Start Date', path: [ 'effectiveStartDate' ] },
  { label: 'Effective End Date', path: [ 'effectiveEndDate' ] },
  { label: 'Exclude From Usage Algorithm', path: [ 'excludeFromUsageAlgorithm' ] },
  { label: 'Contacts', path: [ 'contacts' ] },
  { label: 'Setup Services', path: [ 'setupServices' ] },
  { label: 'Teardown Services', path: [ 'teardownServices' ] },
  { label: 'Hide In Scheduling', path: [ 'hideInScheduling' ] },
  { label: 'Hide In Events', path: [ 'hideInEvents' ] },
  { label: 'Cost', path: [ 'cost' ] },
  // custom fields
  { label: 'Custom Fields', path: [ 'customFields' ] },

]

export const BUILDING_FIELD_OPTIONS = [
  { label: 'Name', path: [ 'name' ] },
  { label: 'Display Name', path: [ 'displayName' ] },
  { label: 'Description', path: [ 'description' ] },
  { label: 'Departments', path: [ 'departments' ] },
  { label: 'Notes', path: [ 'notes' ] },
  { label: 'Address Line 1', path: [ 'addressLine1' ] },
  { label: 'Address Line 2', path: [ 'addressLine2' ] },
  { label: 'City', path: [ 'city' ] },
  { label: 'State', path: [ 'state' ] },
  { label: 'Zipcode', path: [ 'zipcode' ] },
  { label: 'Available Times', path: [ 'availableTimes' ] },
  { label: 'Blocked Out Times', path: [ 'blockedOutTimes' ] },
  { label: 'Blackout Dates', path: [ 'blackoutDates' ] },
  // custom fields
  { label: 'Custom Fields', path: [ 'customFields' ] },
]

export const ORGANIZATIONS_FIELD_OPTIONS = [
  { label: 'Name', path: [ 'name' ] },
  { label: 'Public', path: [ 'public' ] },
  { label: 'Type', path: [ 'type' ] },

  // contacts
  { label: 'Contact ID', path: [ 'contacts', '$', 'id' ] },
  { label: 'Contact Type', path: [ 'contacts', '$', 'type' ] },
  { label: 'Contact Name', path: [ 'contacts', '$', 'name' ] },
  { label: 'Contact Email', path: [ 'contacts', '$', 'email' ] },
  { label: 'Contact Phone', path: [ 'contacts', '$', 'phone' ] },
  { label: 'Contact Role', path: [ 'contacts', '$', 'role' ] },
  { label: 'Contact Notify', path: [ 'contacts', '$', 'notify' ] },
  { label: 'Contact Address', path: [ 'contacts', '$', 'address' ] },

  // custom fields
  { label: 'Custom Fields', path: [ 'customFields' ] },
]

export const DEPARTMENT_FIELD_OPTIONS = [
  { label: 'Name', path: [ 'name' ] },
  { label: 'Display Name', path: [ 'displayName' ] },
  { label: 'Status', path: [ 'status' ] },
  { label: 'Subject Codes', path: [ 'subjectCodes' ] },
  { label: 'Chair', path: [ 'chair' ] },
  { label: 'Workflow Step', path: [ 'workflowStep' ] },
  { label: 'Schedule Status', path: [ 'scheduleStatus' ] },
  { label: 'Preference Type Options', path: [ 'preferenceTypeOptions' ] },
  { label: 'Schedule Validation Workflow Id', path: [ 'scheduleValidationWorkflowId' ] },
  { label: 'Effective Start Date', path: [ 'effectiveStartDate' ] },
  { label: 'Effective End Date', path: [ 'effectiveEndDate' ] },
  { label: 'Hide In Scheduling', path: [ 'hideInScheduling' ] },
  { label: 'Hide In Events', path: [ 'hideInEvents' ] },

  // the following fields exist for use in the public facing catalog
  { label: 'Catalog Display Name', path: [ 'catalogDisplayName' ] },
  { label: 'Catalog Description', path: [ 'catalogDescription' ] },
  { label: 'Catalog Image Url', path: [ 'catalogImageUrl' ] },

  // custom fields
  { label: 'Custom Fields', path: [ 'customFields' ] },
]

export const TERM_FIELD_OPTIONS = [
  { label: 'Display Name', path: [ 'displayName' ] },
  { label: 'Term Description', path: [ 'termDesc' ] },
  { label: 'Start Date', path: [ 'startDate' ] },
  { label: 'End Date', path: [ 'endDate' ] },
  { label: 'Historical', path: [ 'historical' ] },
  { label: 'Public', path: [ 'public' ] },
  { label: 'Parts of Term', path: [ 'partsOfTerm' ] },
  { label: 'Part of Term Exam Period Start Date', path: [ 'partsOfTerm', '$', 'examPeriodStartDate' ] },
  { label: 'Part of Term Exam Period End Date', path: [ 'partsOfTerm', '$', 'examPeriodEndDate' ] },
  { label: 'Part of Term Display Name', path: [ 'partsOfTerm', '$', 'displayName' ] },
  { label: 'Part of Term Description', path: [ 'partsOfTerm', '$', 'partOfTermDesc' ] },
  { label: 'Part of Term Start Date', path: [ 'partsOfTerm', '$', 'startDate' ] },
  { label: 'Part of Term End Date', path: [ 'partsOfTerm', '$', 'endDate' ] },
  { label: 'Exam Period Start Date', path: [ 'examPeriodStartDate' ] },
  { label: 'Exam Period End Date', path: [ 'examPeriodEndDate' ] },
  { label: 'Date Exceptions', path: [ 'dateExceptions' ] },
  { label: 'Conversion Dates', path: [ 'conversionDates' ] },
  { label: 'Phase', path: [ 'phaseId' ] },
  { label: 'Overlapping Terms', path: [ 'overlappingTerms' ] },
]

export const RELATIONSHIP_FIELD_OPTIONS = [
  { label: 'Section Ids', path: [ 'sectionIds' ] },
  { label: 'Course Ids', path: [ 'courseIds' ] },
  { label: 'Section Numbers', path: [ 'sectionNumbers' ] },
  { label: 'Group Id', path: [ 'groupId' ] },
  { label: 'Last Edited At', path: [ 'lastEdited' ] },
  { label: 'Last Edited By', path: [ 'lastEditedBy' ] },
  { label: 'Created At', path: [ 'createdAt' ] },
  { label: 'Created By', path: [ 'createdBy' ] },
  { label: 'Name', path: [ 'name' ] },
  { label: 'Institution', path: [ 'institution' ] },
  { label: 'Relationship', path: [ 'relationship' ] },
  { label: 'Combined Max Enrollment', path: [ 'combinedMaxEnrollment' ] },
  { label: 'Preferred Room Capacity', path: [ 'preferredRoomCapacity' ] },
  { label: 'Section Type', path: [ 'sectionType' ] },
  { label: 'Type', path: [ 'type' ] },
  { label: 'Notes', path: [ 'notes' ] },
  { label: 'Custom Fields', path: [ 'customFields' ] },
  { label: 'Link Id', path: [ 'linkId' ] },
  { label: 'Link Connector', path: [ 'linkConnector' ] },
  { label: 'Link Section Ids', path: [ 'linkedSectionIds' ] },
]

export const COURSE_ATTRIBUTES_FIELD_OPTIONS = [
  { label: 'Coursedog _ID', path: [ '_id' ] },
  { label: 'Description', path: [ 'description' ] },
  { label: 'Description Short', path: [ 'descriptionShort' ] },
  { label: 'Status', path: [ 'status' ] },
  { label: 'Effective Start Date', path: [ 'effectiveStartDate' ] },
  { label: 'Code', path: [ 'code' ] },
  { label: 'Parent Code', path: [ 'parentCode' ] },
  { label: 'Attribute Value', path: [ 'value' ] },
]

export const NOTE_FIELD_OPTIONS = [
  { label: 'Description', path: [ 'description' ] },
  { label: 'Description Long', path: [ 'descriptionLong' ] },
  { label: 'Status', path: [ 'status' ] },
  { label: 'Effective Start Date', path: [ 'effectiveStartDate' ] },
  { label: 'Code', path: [ 'code' ] },
]

export const REQUIREMENT_GROUPS_FIELD_OPTIONS = [
  { label: 'Description', path: [ 'description' ] },
  { label: 'Description Long', path: [ 'descriptionLong' ] },
  { label: 'Status', path: [ 'status' ] },
  { label: 'Effective Start Date', path: [ 'effectiveStartDate' ] },
  { label: 'Code', path: [ 'code' ] },
  { label: 'Parent Code', path: [ 'parentCode' ] },
  { label: 'Notes', path: [ 'notes' ] },
]

export const EMPLOYEE_RECORDS_FIELD_OPTIONS = [
  { label: 'Description', path: [ 'description' ] },
  { label: 'Professor ID', path: [ 'professorId' ] },
  { label: 'Department ID', path: [ 'departmentId' ] },
  { label: 'Institution ID', path: [ 'institutionId' ] },
  { label: 'Code', path: [ 'code' ] },
  { label: 'Description', path: [ 'description' ] },
  { label: 'Professor Status', path: [ 'professorStatus' ] },
  { label: 'HR Status', path: [ 'hrStatus' ] },
  { label: 'Per Org', path: [ 'perOrg' ] },
  { label: 'Effective Start Date', path: [ 'effectiveStartDate' ] },
  { label: 'Fulltime', path: [ 'fullTime' ] },
  { label: 'Record Number', path: [ 'recordNumber' ] },
]

export const CAMPUS_LOCATIONS_FIELD_OPTIONS = [
  { label: 'Campus', path: [ 'campus' ] },
  { label: 'Institution ID', path: [ 'institutionId' ] },
  { label: 'Primary Location', path: [ 'primaryLocation' ] },
  { label: 'Description', path: [ 'description' ] },
  { label: 'Description (Short)', path: [ 'descriptionShort' ] },
  { label: 'Status', path: [ 'status' ] },
  { label: 'Effective Start Date', path: [ 'effectiveStartDate' ] },
  { label: 'Locations', path: [ 'locations' ] },
]

export const PROGRAM_FIELD_OPTIONS = [
  { label: 'Code', path: [ 'code' ] },
  { label: 'Level', path: [ 'level' ] },
  { label: 'Type', path: [ 'type' ] },
  { label: 'Career', path: [ 'career' ] },
  { label: 'Name', path: [ 'name' ] },
  { label: 'Long Name', path: [ 'longName' ] },
  { label: 'Description', path: [ 'description' ] },
  { label: 'Diploma Description', path: [ 'diplomaDescription' ] },
  { label: 'Departments', path: [ 'departments' ] },
  { label: 'Owners', path: [ 'owners' ] },
  { label: 'Delivery', path: [ 'delivery' ] },
  { label: 'Registration Mode', path: [ 'registrationMode' ] },
  { label: 'Attributes', path: [ 'attributes' ] },
  { label: 'Status', path: [ 'status' ] },
  { label: 'Degree Designation', path: [ 'degreeDesignation' ] },
  { label: 'Degree Designations', path: [ 'degreeDesignations' ] },
  { label: 'Notes', path: [ 'notes' ] },
  { label: 'Contacts', path: [ 'contacts' ] },
  { label: 'Learning Outcomes', path: [ 'learningOutcomes' ] },
  { label: 'Instructional Methods', path: [ 'instructionalMethods' ] },
  { label: 'Requirements', path: [ 'requisites' ] },
  { label: 'Requirement Levels', path: [ 'requirementLevels' ] },
  { label: 'Degree Maps', path: [ 'degreeMaps' ] },
  { label: 'Specializations', path: [ 'specializations' ] },
  { label: 'Concentrations', path: [ 'concentrations' ] },
  { label: 'Effective Start Date', path: [ 'effectiveStartDate' ] },
  { label: 'Effective End Date', path: [ 'effectiveEndDate' ] },
  { label: 'CIP Code', path: [ 'cipCode' ] },
  { label: 'Hegis Code', path: [ 'hegisCode' ] },

  // Peoplesoft SIS Fields
  { label: 'First Term Valid', path: [ 'firstTermValid' ] },
  { label: 'Last Admit Term', path: [ 'lastAdmitTerm' ] },
  { label: 'Last Prospect Date', path: [ 'lastProspectDate' ] },
  { label: 'Field Of Study', path: [ 'fieldOfStudy' ] },
  { label: 'Program Level', path: [ 'level' ] },
  { label: 'Transcript Level', path: [ 'transcriptLevel' ] },
  { label: 'Program Length Type', path: [ 'programLengthType' ] },
  { label: 'Nsc Classification', path: [ 'nscClassification' ] },
  { label: 'Requirement Term Default', path: [ 'defaultOfRequirementTerm' ] },
  { label: 'Sula Special Program', path: [ 'sulaSpecialProgram' ] },
  { label: 'Evaluate Plan Before Program', path: [ 'evaluatePlanBeforeProgram' ] },

  // specialization fields
  { label: 'Specialization Type', path: [ 'specializations', '$', 'type' ] },
  { label: 'Specialization Raw SIS ID', path: [ 'specializations', '$', 'rawSisId' ] },
  { label: 'Specialization Requirement Term Default', path: [ 'specializations', '$', 'defaultOfRequirementTerm' ] },
  { label: 'Specialization Transcript Level', path: [ 'specializations', '$', 'transcriptLevel' ] },
  { label: 'Specialization Status', path: [ 'specializations', '$', 'status' ] },
  { label: 'Specialization Last Admit Term', path: [ 'specializations', '$', 'lastAdmitTerm' ] },

  // meta information
  { label: 'Deprecated Coursedog Id', path: [ 'deprecatedId' ] },
  { label: 'Deprecated Coursedog Group Id', path: [ 'deprecatedProgramGroupId' ] },
  { label: 'Raw SIS ID', path: [ 'rawSisId' ] },
  { label: 'Version', path: [ 'version' ] },
  { label: 'Program Group Id', path: [ 'programGroupId' ] },
  { label: 'Allow Integration', path: [ 'allowIntegration' ] },
  { label: 'Object Merge Settings', path: [ 'objectMergeSettings' ] },

  // custom fields
  { label: 'Custom Fields', path: [ 'customFields' ] },

  // catalog fields
  { label: 'Career Paths', path: [ 'careerPaths' ] },
  { label: 'Catalog Display Name', path: [ 'catalogDisplayName' ] },
  { label: 'Catalog Image', path: [ 'catalogDisplayName' ] },
  { label: 'Catalog Short Description', path: [ 'catalogDescription' ] },
  { label: 'Catalog Full Description', path: [ 'catalogFullDescription' ] },
  { label: 'Career Categories', path: [ 'careerCategories' ] },
  { label: 'Interests', path: [ 'interests' ] },
  { label: 'Academic Focus', path: [ 'academicFocus' ] },
  { label: 'Catalog Quote', path: [ 'catalogQuote' ] },
  { label: 'Catalog Quote Author', path: [ 'catalogQuoteAuthor' ] },

]

export const GRADE_MODES_FIELD_OPTIONS = [
  { label: 'Grade Mode', path: [ 'gradeMode' ] },
  { label: 'Institution ID', path: [ 'institutionId' ] },
  { label: 'Description', path: [ 'description' ] },
  { label: 'Formal Description', path: [ 'descriptionFormal' ] },
  { label: 'Status', path: [ 'status' ] },
  { label: 'Effective Start Date', path: [ 'effectiveStartDate' ] },
]

export const CIP_CODES_FIELD_OPTIONS = [
  { label: 'Cip Code', path: [ 'cipCode' ] },
  { label: 'Description', path: [ 'description' ] },
  { label: 'Status', path: [ 'status' ] },
  { label: 'Country', path: [ 'country' ] },
  { label: 'Short Description', path: [ 'descriptionShort' ] },
  { label: 'Long Description', path: [ 'descriptionLong' ] },
]

export const HEGIS_CODES_FIELD_OPTIONS = [
  { label: 'Code', path: [ 'code' ] },
  { label: 'Description', path: [ 'description' ] },
  { label: 'Effective Date', path: [ 'effectiveDate' ] },
  { label: 'Status', path: [ 'status' ] },
  { label: 'Short Description', path: [ 'descriptionShort' ] },
]

export const FIELDS_OF_STUDY_FIELDS_OPTIONS = [
  { label: 'Code', path: [ 'code' ] },
  { label: 'Description', path: [ 'description' ] },
  { label: 'Effective Date', path: [ 'effectiveDate' ] },
  { label: 'Status', path: [ 'status' ] },
  { label: 'Short Description', path: [ 'descriptionShort' ] },
  { label: 'Long Description', path: [ 'descriptionLong' ] },
  { label: 'Name Display', path: [ 'displayName' ] },
]

export const DEGREE_FIELDS_OPTIONS = [
  { label: 'Code', path: [ 'code' ] },
  { label: 'Description', path: [ 'description' ] },
  { label: 'Effective Date', path: [ 'effectiveDate' ] },
  { label: 'Status', path: [ 'status' ] },
  { label: 'Short Description', path: [ 'descriptionShort' ] },
  { label: 'Long Description', path: [ 'descriptionLong' ] },
  { label: 'Level Education', path: [ 'educationLevel' ] },
  { label: 'Duration', path: [ 'duration' ] },
  { label: 'Internal', path: [ 'internal' ] },
  { label: 'Name Display', path: [ 'displayName' ] },
]

export const ACADEMIC_CAREERS_FIELDS = [
  { label: 'Type', path: [ 'type' ] },
  { label: 'Name', path: [ 'name' ] },
  { label: 'Code', path: [ 'code' ] },
  { label: 'Description', path: [ 'description' ] },
  { label: 'Effective Date', path: [ 'effectiveDate' ] },
  { label: 'Status', path: [ 'status' ] },
  { label: 'Short Description', path: [ 'descriptionShort' ] },
  { label: 'Long Description', path: [ 'descriptionLong' ] },
  { label: 'Term Measure', path: [ 'termMeasure' ] },
  { label: 'Default Grade Mode', path: [ 'defaultGradeMode' ] },
  { label: 'Custom Fields', path: [ 'customFields' ] },
]

export const COLLEGE_FIELDS_OPTIONS = [
  { label: 'Name', path: [ 'name' ] },
  { label: 'Code', path: [ 'code' ] },
  { label: 'Description', path: [ 'description' ] },
  { label: 'Effective Date', path: [ 'effectiveDate' ] },
  { label: 'Status', path: [ 'status' ] },
  { label: 'Short Description', path: [ 'descriptionShort' ] },
  { label: 'Display Name', path: [ 'displayName' ] },
  { label: 'Custom Fields', path: [ 'customFields' ] },
  { label: 'Meeting Patters Name', path: [ 'meetingPatterns', '$', 'name' ] },
  { label: 'Meeting Patters Description', path: [ 'meetingPatterns', '$', 'description' ] },
  { label: 'Meeting Patters Days', path: [ 'meetingPatterns', '$', 'days' ] },
  { label: 'Meeting Patters Duration', path: [ 'meetingPatterns', '$', 'duration' ] },
  { label: 'Meeting Patters Effective Date', path: [ 'meetingPatterns', '$', 'effectiveDate' ] },
]

export const COURSE_COMPONENTS_FIELDS_OPTIONS = [
  { label: 'Type', path: [ 'type' ] },
  { label: 'Name', path: [ 'name' ] },
  { label: 'Code', path: [ 'code' ] },
]

export const MILESTONES_FIELDS_OPTIONS = [
  { label: 'Name', path: [ 'name' ] },
  { label: 'Code', path: [ 'code' ] },
  { label: 'Description', path: [ 'description' ] },
  { label: 'Effective Date', path: [ 'effectiveDate' ] },
  { label: 'Status', path: [ 'status' ] },
  { label: 'Print Milestone Detail', path: [ 'printMilestoneDetail' ] },
]

export const REQUIREMENT_DESIGNATION_FIELDS_OPTIONS = [
  { label: 'Code', path: [ 'code' ] },
  { label: 'Name', path: [ 'name' ] },
  { label: 'Description', path: [ 'description' ] },
  { label: 'Effective Date', path: [ 'effectiveDate' ] },
  { label: 'Status', path: [ 'status' ] },
  { label: 'Short Description', path: [ 'descriptionShort' ] },
  { label: 'Print Schedule', path: [ 'schedulePrint' ] },
  { label: 'catalogPrint', path: [ 'catalogPrint' ] },
  { label: 'CU Requirement Designation', path: [ 'cuRequirementDesignation' ] },
]

export const EQUIVALENT_COURSE_GROUP_FIELDS_OPTIONS = [
  { label: 'Name', path: [ 'name' ] },
  { label: 'Code', path: [ 'code' ] },
  { label: 'Description', path: [ 'description' ] },
  { label: 'Effective Date', path: [ 'effectiveDate' ] },
  { label: 'Status', path: [ 'status' ] },
  { label: 'Display Name', path: [ 'displayName' ] },
]

export const TUITION_GROUPS_FIELDS_OPTIONS = [
  { label: 'Name', path: [ 'name' ] },
  { label: 'Code', path: [ 'code' ] },
  { label: 'Display Name', path: [ 'displayName' ] },
  { label: 'Effective Date', path: [ 'effectiveDate' ] },
  { label: 'Status', path: [ 'status' ] },
]

export const SUBJECT_CODE_FIELDS_OPTIONS = [
  { label: 'ID', path: [ '_id' ] },
  { label: 'Subject Code', path: [ 'subjectCode' ] },
  { label: 'Description', path: [ 'description' ] },
  { label: 'Short Description', path: [ 'descriptionShort' ] },
  { label: 'Effective Date', path: [ 'effectiveDate' ] },
  { label: 'Status', path: [ 'status' ] },
  { label: 'Department', path: [ 'department' ] },
  { label: 'Cip Code', path: [ 'cipCode' ] },
  { label: 'Hegis Code', path: [ 'hegisCode' ] },
  { label: 'Field of Study', path: [ 'fieldOfStudy' ] },
  { label: 'Split Owner', path: [ 'splitOwner' ] },
  { label: 'Use Blind Grading', path: [ 'useBlindGrading' ] },
]

export const PROGRAM_LEVELS_FIELDS_OPTIONS = [
  { label: 'Name', path: [ 'name' ] },
  { label: 'Code', path: [ 'code' ] },
  { label: 'Description', path: [ 'description' ] },
  { label: 'Career', path: [ 'career' ] },
  { label: 'College', path: [ 'college' ] },
  { label: 'Academic Standing', path: [ 'academicStanding' ] },
  { label: 'Academic Level', path: [ 'academicLevel' ] },
  { label: 'Residency Required', path: [ 'residencyRequired' ] },
  { label: 'Campus', path: [ 'campus' ] },
  { label: 'Effective Date', path: [ 'effectiveDate' ] },
  { label: 'Status', path: [ 'status' ] },
  { label: 'Default Grade Mode', path: [ 'defaultGradeMode' ] },
  { label: 'Cip Code', path: [ 'cipCode' ] },
  { label: 'Hegis Code', path: [ 'hegisCode' ] },
  { label: 'Start Term Year', path: [ 'startTerm', '$', 'year' ] },
  { label: 'Start Term Semester', path: [ 'startTerm', '$', 'semester' ] },
  { label: 'Start Term ID', path: [ 'startTerm', '$', 'id' ] },
  { label: 'End Term Year', path: [ 'endTerm', '$', 'year' ] },
  { label: 'End Term Semester', path: [ 'endTerm', '$', 'semester' ] },
  { label: 'End Term ID', path: [ 'endTerm', '$', 'id' ] },
  { label: 'Custom Fields', path: [ 'customFields' ] },
]

export const DEFAULT_TRANSLATE_VALUE_FIELD_OPTIONS = [
  { label: 'ID', path: [ '_id' ] },
  { label: 'Field Name', path: [ 'fieldName' ] },
  { label: 'Code', path: [ 'code' ] },
  { label: 'Name', path: [ 'name' ] },
  { label: 'Display Name', path: [ 'displayName' ] },
  { label: 'Effective Date', path: [ 'effectiveDate' ] },
  { label: 'Status', path: [ 'status' ] },
]

export const EVENT_FIELD_OPTIONS = [
  { label: 'Contact - Email', path: [ 'contact', '$', 'email' ] },
  { label: 'Contact - Name', path: [ 'contact', '$', 'name' ] },
  { label: 'Contact - Phone', path: [ 'contact', '$', 'phone' ] },
  { label: 'Event ID', path: [ 'callNumber' ] },
  { label: 'Organization', path: [ 'organization' ] },
  { label: 'Event Name', path: [ 'name' ] },
  { label: 'Event Description', path: [ 'description' ] },
  { label: 'Featured', path: [ 'featured' ] },
  { label: 'Private', path: [ 'private' ] },
  { label: 'Notes', path: [ 'notes' ] },
  { label: 'Custom Fields', path: [ 'customFields' ] },
]

export const STUDENT_AUDIT_FIELD_OPTIONS = [
  { label: 'Audit ID', path: [ 'auditId' ] },
  { label: 'Student ID', path: [ 'studentId' ] },
  { label: 'Source', path: [ 'source' ] },
  { label: 'Program', path: [ 'program' ] },
  { label: 'School', path: [ 'school' ] },
  { label: 'Degree', path: [ 'degree' ] },
  { label: 'Goals', path: [ 'goals' ] },
  { label: 'Courses Applied', path: [ 'coursesApplied' ] },
  { label: 'SIS ID', path: [ 'sisId' ] },
  { label: 'Custom Fields', path: [ 'customFields' ] },
]

export const ENROLLMENT_REQUIREMENTS_FIELD_OPTIONS = [
  { label: 'Effective Date', path: [ 'effectiveDate' ] },
  { label: 'Requirement Line Table', path: [ 'rqLineTbl' ] },
]

export const STUDENT_FIELD_OPTIONS = [
  { label: 'Name', path: [ 'name' ] },
  { label: 'Goals', path: [ 'goals' ] },
  { label: 'Attributes', path: [ 'attributes' ] },
  { label: 'Custom Fields', path: [ 'customFields' ] },
]

export const MERGE_FIELD_OPTIONS = {
  courses: COURSE_FIELD_OPTIONS,
  coursesCm: COURSE_CM_FIELD_OPTIONS,
  sections: SECTION_FIELD_OPTIONS,
  professors: PROFESSOR_FIELD_OPTIONS,
  rooms: ROOM_FIELD_OPTIONS,
  buildings: BUILDING_FIELD_OPTIONS,
  departments: DEPARTMENT_FIELD_OPTIONS,
  terms: TERM_FIELD_OPTIONS,
  relationships: RELATIONSHIP_FIELD_OPTIONS,
  courseAttributes: COURSE_ATTRIBUTES_FIELD_OPTIONS,
  notes: NOTE_FIELD_OPTIONS,
  requirementGroups: REQUIREMENT_GROUPS_FIELD_OPTIONS,
  employeeRecords: EMPLOYEE_RECORDS_FIELD_OPTIONS,
  campusLocations: CAMPUS_LOCATIONS_FIELD_OPTIONS,
  programs: PROGRAM_FIELD_OPTIONS,
  gradeModes: GRADE_MODES_FIELD_OPTIONS,
  cipCodes: CIP_CODES_FIELD_OPTIONS,
  hegisCodes: HEGIS_CODES_FIELD_OPTIONS,
  fieldsOfStudy: FIELDS_OF_STUDY_FIELDS_OPTIONS,
  degrees: DEGREE_FIELDS_OPTIONS,
  academicCareers: ACADEMIC_CAREERS_FIELDS,
  colleges: COLLEGE_FIELDS_OPTIONS,
  courseComponents: COURSE_COMPONENTS_FIELDS_OPTIONS,
  milestones: MILESTONES_FIELDS_OPTIONS,
  requirementDesignations: REQUIREMENT_DESIGNATION_FIELDS_OPTIONS,
  equivalentCourseGroups: EQUIVALENT_COURSE_GROUP_FIELDS_OPTIONS,
  tuitionGroups: TUITION_GROUPS_FIELDS_OPTIONS,
  subjectCodes: SUBJECT_CODE_FIELDS_OPTIONS,
  programLevels: PROGRAM_LEVELS_FIELDS_OPTIONS,
  sulaSpecialPrograms: DEFAULT_TRANSLATE_VALUE_FIELD_OPTIONS,
  nscClassifications: DEFAULT_TRANSLATE_VALUE_FIELD_OPTIONS,
  events: EVENT_FIELD_OPTIONS,
  organizations: ORGANIZATIONS_FIELD_OPTIONS,
  studentAudits: STUDENT_AUDIT_FIELD_OPTIONS,
  enrollmentRequirements: ENROLLMENT_REQUIREMENTS_FIELD_OPTIONS,
  students: STUDENT_FIELD_OPTIONS,
}

export const MERGE_TYPES = [
  'terms',
  'departments',
  'buildings',
  'rooms',
  'professors',
  'notes',
  'cipCodes',
  'hegisCodes',
  'campusLocations',
  'gradeModes',
  'employeeRecords',
  'academicCareers',
  'colleges',
  'requirementGroups',
  'courseAttributes',
  'courseComponents',
  'milestones',
  'requirementDesignations',
  'equivalentCourseGroups',
  'subjectCodes',
  'sections',
  'coursesCm',
  'courses',
  'relationships',
  'programLevels',
  'sulaSpecialPrograms',
  'nscClassifications',
  'tuitionGroups',
  'degrees',
  'fieldsOfStudy',
  'programs',
  'users',
  'organizations',
  'students',
  'enrollmentRequirements',
  'studentAudits',
  'events',
  'programRequisites',
]

export const CONFLICT_RESOLUTION_METHODS = {
  manualResolution: { description: 'You must resolve any conflicts manually.' },
  resolveAsCoursedog: { description: 'Conflicts will be automatically resolved according to Coursedog\'s value.' },
  resolveAsInstitution: { description: 'Conflicts will be automatically resolved according to the school\'s value.' },
  alwaysCoursedog: { description: 'All values will be taken from Coursedog\'s data.' },
  alwaysInstitution: { description: 'All values will be taken from the school\'s data.' },
}
